// ============================================================
// Input — Square Code text input
//
// Calm, mono-labelled, glassmorphic. Supports all native input
// props. Visual states: idle, focus, error, disabled.
// Controlled or uncontrolled — pass `value` for controlled.
// ============================================================

import { forwardRef, useState } from 'react'

const Input = forwardRef(function Input(
  {
    error = false,
    icon = null,
    type = 'text',
    style: styleOverride,
    onFocus,
    onBlur,
    disabled = false,
    ...rest
  },
  ref
) {
  const [focused, setFocused] = useState(false)

  const borderColor = error
    ? 'var(--olv-red)'
    : focused
      ? 'var(--olv-purple)'
      : 'rgba(255,255,255,0.08)'

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {icon && (
        <span style={{
          position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
          color: 'var(--olv-text-tertiary)', pointerEvents: 'none',
          display: 'flex', alignItems: 'center',
        }}>
          {icon}
        </span>
      )}
      <input
        ref={ref}
        type={type}
        disabled={disabled}
        onFocus={(e) => { setFocused(true); onFocus?.(e) }}
        onBlur={(e) => { setFocused(false); onBlur?.(e) }}
        style={{
          width: '100%',
          padding: icon ? '10px 14px 10px 36px' : '10px 14px',
          background: disabled ? 'rgba(255,255,255,0.02)' : 'rgba(12,12,20,0.6)',
          border: `1px solid ${borderColor}`,
          borderRadius: 'var(--olv-radius-card)',
          color: disabled ? 'var(--olv-text-tertiary)' : 'var(--olv-text-primary)',
          fontSize: 13,
          fontFamily: 'var(--font-body)',
          outline: 'none',
          transition: 'border-color 200ms var(--ease-standard)',
          backdropFilter: 'blur(8px)',
          cursor: disabled ? 'not-allowed' : 'text',
          ...styleOverride,
        }}
        {...rest}
      />
    </div>
  )
})

export default Input
